import React, { useMemo } from "react";
import PmoTooltip from "../../ProductMarketingOptimization/components/common/PmoTooltip";
import BrandPerformanceTable from "../../../components/Tables/BrandPerformanceTable";
import LoadingEllipsis from "../../../components/Loading/LoadingEllipsis";
import { NoDataMsg } from "../../../components/AppMessages";

interface Props {
  title: string;
  tableId: string;
  TableTooltipParagraphs?: () => JSX.Element;
  tableData: any;
  columns: any;
  loadingTable: boolean;
  initialSortCol?: any;
  nestedInData?: boolean;
}

const BrandPerformanceTableTile = (props: Props) => {
  const { title, tableId, tableData, columns, loadingTable, TableTooltipParagraphs, initialSortCol, nestedInData = true } = props;

  const dateRange = tableData?.date_range ?? [];

  const dateTitle = useMemo(() => {
    if (dateRange && dateRange.length > 1) {
      return `(${dateRange[0]} - ${dateRange.slice(-1)})`;
    } else if (dateRange && dateRange.length == 1) {
      return `(${dateRange[0]})`;
    }

    return "";
  }, [dateRange]);

  const tableDataLength = nestedInData ? tableData?.data?.length : tableData?.length;
  return (
    <div className="primary_background ">
      <div className="header" style={{ padding: "1.5em" }}>
        <div className="title_container">
          <h3>
            {title} {dateTitle}
          </h3>
          {TableTooltipParagraphs && <PmoTooltip paragraphs={<TableTooltipParagraphs />} />}
        </div>
      </div>
      <div className="chart_content brand_perf_table" style={{ margin: "1em" }}>
        {tableDataLength && !loadingTable ? (
          <BrandPerformanceTable
            isLoading={loadingTable}
            columns={columns ?? []}
            tableId={tableId}
            data={nestedInData ? tableData?.data ?? [] : tableData ?? []}
            initialSortCol={initialSortCol}
          />
        ) : loadingTable ? (
          <LoadingEllipsis isLoading={loadingTable} />
        ) : (
          <NoDataMsg message="No data available" />
        )}
      </div>
    </div>
  );
};

export default BrandPerformanceTableTile;
